import React, { useState, useEffect } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import Confirm from 'react-confirm-bootstrap';

import CommonTable from '../../CommonTable/CommonTable';
import Link from '../../Link';
import CustomPagination from '../../CustomPagination';
import SMTPModal from './SMTPModal/SMTPModal';
import Loader from '../../Loader/Loader';

import messages from '../../../locale/messages';
import { openSmtpSetupModal } from '../../../actions/siteadmin/modalActions';
import { updateSmtpActiveStatus } from '../../../actions/siteadmin/SmtpSetup/updateSmtpActiveStatus';
import { deleteSmtpSetup } from '../../../actions/siteadmin/SmtpSetup/manageSmtpData';
import { demoRestriction, demoRestrictionEncode } from '../../../helpers/DemoRestriction/demoRestriction';
import { getCensorFormData } from '../../../helpers/SmtpSetup/getFormData';

import { withQuery } from '../../../hoc/withGraphql';
import { getAllSmtpData } from '../../../lib/graphql';

import s from './SMTPManagement.css';
import bt from '../../../components/commonStyle.css';

function SMTPManagement(props) {
  const {
    data: { getAllSmtpData = {}, refetch, loading },
    currentPage,
    setStateVariable
  } = props;

  const intl = useIntl();
  const dispatch = useDispatch();

  const [isDemoRestrict, setRestrict] = useState('false');

  useEffect(() => {
    async function fetchData() {
      const isRestrict = await dispatch(demoRestrictionEncode());
      setRestrict(isRestrict);
    }
    fetchData();
  }, []);

  const handleModalOpen = (value) => {
    const formData = getCensorFormData(value, isDemoRestrict);
    if (value?.id) {
      dispatch(openSmtpSetupModal('edit', formData));
    } else {
      dispatch(openSmtpSetupModal('add'));
    }
  };

  const handleUpdate = async (id) => {
    const pageFix = currentPage > 1 && getAllSmtpData?.results?.length === 1 ? currentPage - 1 : currentPage;
    const isRestrict = await dispatch(demoRestriction({}));
    if (isRestrict) return;
    await dispatch(updateSmtpActiveStatus(id));
    setStateVariable({ currentPage: 1 });
    await refetch({ currentPage: pageFix });
  };

  const handleDelete = async (id) => {
    const pageFix = currentPage > 1 && getAllSmtpData?.results?.length === 1 ? currentPage - 1 : currentPage;
    const isRestrict = await dispatch(demoRestriction({ restrictType: 'SMTP', restrictValue: id }));
    if (isRestrict) return;
    await dispatch(deleteSmtpSetup({ id }));
    setStateVariable({ currentPage: 1 });
    await refetch({ currentPage: pageFix });
  };

  const paginationData = (newPage) => {
    const variables = { currentPage: newPage };
    setStateVariable(variables);
    refetch(variables);
  };

  const thead = () => [
    { data: intl.formatMessage(messages.idLabel) },
    { data: intl.formatMessage(messages.smtpName) },
    { data: intl.formatMessage(messages.setActive) },
    { data: intl.formatMessage(messages.status) },
    { data: intl.formatMessage(messages.editLabel) },
    { data: intl.formatMessage(messages.delete) }
  ];

  const tbody = () =>
    getAllSmtpData?.results?.map((value, key) => ({
      id: key,
      data: [
        { data: value?.id },
        { data: value?.smtpName },
        {
          data: !value?.isActive && (
            <Link noLink onClick={() => handleUpdate(value?.id)}>
              <FormattedMessage {...messages.setAsActive} />
            </Link>
          )
        },
        {
          data: value?.isEnable
            ? intl.formatMessage(messages.enabledLabel)
            : intl.formatMessage(messages.disabledLabel)
        },
        {
          data: (
            <Link noLink onClick={() => handleModalOpen(value)}>
              <FormattedMessage {...messages.editLabel} />
            </Link>
          )
        },
        {
          data: (
            <Confirm
              onConfirm={() => handleDelete(value?.id)}
              body={intl.formatMessage(messages.areYouSureDeleteWishList)}
              confirmText={intl.formatMessage(messages.confirmDelete)}
              cancelText={intl.formatMessage(messages.cancel)}
              title={intl.formatMessage(messages.deletingSMTP)}
            >
              <a href="javascript:void(0)">
                <FormattedMessage {...messages.delete} />
              </a>
            </Confirm>
          )
        }
      ]
    }));

  return (
    <div>
      {loading && <div><Loader type={"text"} /></div>}
      {!loading && <div>
        <SMTPModal paginationData={paginationData} currentPage={currentPage} />
        <CommonTable
          thead={thead}
          tbody={tbody}
          title={intl.formatMessage(messages.smtpSetupLabel)}
          addAction={handleModalOpen}
          redirectionLabel={intl.formatMessage(messages.addNewLabel)}
        />
        {getAllSmtpData?.count > 0 && (
          <CustomPagination
            total={getAllSmtpData?.count}
            currentPage={currentPage}
            defaultCurrent={1}
            defaultPageSize={10}
            change={paginationData}
            paginationLabel={intl.formatMessage(messages.smtpSetupLabel)}
            isScroll
          />
        )}
      </div>}
    </div>
  );
}

export default withQuery(getAllSmtpData, {
  options: (props) => ({
    variables: {
      currentPage: props.currentPage
    },
    fetchPolicy: 'network-only',
    ssr: false
  })
})(withStyles(s, bt)(SMTPManagement));